import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-register-popover',
    templateUrl: './register-popover.component.html',
    styleUrls: ['./register-popover.component.scss'],
    standalone: false
})
export class RegisterPopoverComponent implements OnInit {

  @Input() registers;
  @Input() index;

  constructor() { }

  ngOnInit(): void {
  }

}
